"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncedSearchResultCount = void 0;
const react_1 = __importStar(require("react"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const styles_1 = require("./styles");
/**
 * A default screen reader message for the search result count
 * @param count
 * @returns string
 */
const defaultAriaLiveLabel = (count) => {
    if (count === 0)
        return 'No results found';
    const result = count === 1 ? 'result' : 'results';
    return `Found ${count} ${result}`;
};
/**
 * Renders a screen reader only aria-live message for a search result count
 * that updates 1 second after the last `count` prop update
 *
 * Default props: `aria-live="polite"` and `aria-atomic="true"`
 *
 * Example content: "Found 1 result(s)"
 */
const AnnouncedSearchResultCount = (_a) => {
    var { count, searching, ariaLiveLabel = defaultAriaLiveLabel } = _a, props = __rest(_a, ["count", "searching", "ariaLiveLabel"]);
    const [newCount, setNewCount] = (0, react_1.useState)(count);
    const updateCount = (0, react_1.useMemo)(() => (0, debounce_1.default)((updatedCount) => {
        setNewCount(updatedCount);
    }, 1000), [setNewCount]);
    (0, react_1.useEffect)(() => updateCount(count), [updateCount, count]);
    const searchMessage = (0, react_1.useMemo)(() => {
        if (searching) {
            return ariaLiveLabel(newCount);
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    }, [ariaLiveLabel, newCount, searching]);
    return (react_1.default.createElement(styles_1.SearchCountMessage, Object.assign({ "aria-live": "polite", "aria-atomic": "true" }, props), searchMessage));
};
exports.AnnouncedSearchResultCount = AnnouncedSearchResultCount;
//# sourceMappingURL=AnnouncedSearchResultCount.js.map